import { EMPTY_LIST, ENTITY_LISTING_VIEW_TYPE } from '../../../constants/common'
import {
  DATE_FILTER_TYPE,
  SELECT_FILTER_TYPE,
  TOGGLE_FILTER_TYPE,
} from '../../../constants/filter'
import { QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED } from '../../../constants/qa'
import { RENTAL_PORTAL_APPLICANT_SOURCE_LABEL_KEY } from '../../../constants/rentalPortal'
import {
  APPLICANT_STAGE_LIST,
  APPLICANT_STAGES,
  APPLICANTS_FILTER_PARAM,
} from '../../RentalPortalApplicant'
import { MATCH_ELIGIBILITY_STATUSES } from '../RentalPortalMatch'

import { RentalPortalApplicantsEligibilityFilterListItem } from './RentalPortalApplicantsEligibilityFilterListItem'
import { RentalPortalApplicantsStageFilterListItem } from './RentalPortalApplicantsStageFilterListItem'

export const QA_NAME_APPLICANTS_ADD_NEW = 'addNewApplicant'

export const QA_NAME_APPLICANT_DRAFT_CREATE_ACTION_MODAL =
  'applicantDraftCreate'

export const QA_NAME_APPLICANT_DRAFT_CLOSE_ACTION_MODAL = 'applicantDraftClose'

export const APPLICANT_DRAFT_PREFIX = 'rental-portal-applicant'

export const APPLICANT_MINIMIZED_REPLACE_CONFIRMATION = {
  description: 'RentalPortal.ListingMinimizedDraftSavedConfirmationTextKey',
  qaName: QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED,
}

export const QA_NAME_APPLICANTS_CLEAR_FILTERS = 'applicantsClearFilters'

export const QA_NAME_APPLICANTS_PAGE = 'rentalPortalApplicants'

export const QA_NAME_APPLICANTS_PREVIEW = 'applicantsPreview'

export const QA_NAME_APPLICANTS_FIT_SORT_NOTICE = 'applicantsFitSortNotice'

export const QA_NAME_APPLICANTS_REFRESH_ERROR = 'applicantsRefreshError'

export const QA_NAME_APPLICANTS_RETRY = 'applicantsRetry'

export const QA_NAME_APPLICANTS_TABLE = 'applicants'

export const APPLICANT_CREATE_ACTION_NAME = 'createApplicant'

export const APPLICANTS_FILTER_BAR_ITEMS_PROPS = { ShareTemplateButton: null }

export const APPLICANTS_PAGE_SIZE = 20

export const APPLICANTS_TABLE_SKELETON_ROWS = 10

export const APPLICANT_ACTION_OPEN = 'open'

export const APPLICANT_ACTION_ARCHIVE = 'archive'

export const APPLICANT_ACTION_ARCHIVE_MASS = 'archiveMass'

export const APPLICANT_MASS_ACTION = { archive: 'archive' }

export const APPLICANT_MASS_ACTION_NAMES = {
  [APPLICANT_ACTION_ARCHIVE]: APPLICANT_MASS_ACTION.archive,
  [APPLICANT_ACTION_ARCHIVE_MASS]: APPLICANT_MASS_ACTION.archive,
}

export const APPLICANT_COLUMN_NAME = {
  Chips: 'match_chips',
  Fit: 'match',
  Listing: 'listing_label',
  Portal: 'source',
  Received: 'received',
  Reference: 'reference',
  Stage: 'stage',
  WaitingOn: 'waiting_on',
}

export const APPLICANT_COLUMN_CONFIG = {
  [APPLICANT_COLUMN_NAME.Chips]: {
    index: 6,
    title: 'RentalPortal.MatchColumnChipsKey',
    width: 440,
  },
  [APPLICANT_COLUMN_NAME.Fit]: {
    index: 5,
    title: 'RentalPortal.MatchColumnFitKey',
    width: 320,
  },
  [APPLICANT_COLUMN_NAME.Listing]: {
    index: 1,
    title: 'RentalPortal.ApplicantListingColumnKey',
    width: 260,
  },
  [APPLICANT_COLUMN_NAME.Portal]: {
    index: 2,
    title: 'RentalPortal.ApplicantPortalColumnKey',
    width: 200,
  },
  [APPLICANT_COLUMN_NAME.Received]: {
    index: 3,
    title: 'RentalPortal.ListingProfileApplicantsReceivedColumnKey',
    width: 160,
  },
  [APPLICANT_COLUMN_NAME.Reference]: {
    index: 0,
    title: 'RentalPortal.ListingProfileApplicantsApplicantColumnKey',
    width: 260,
  },
  [APPLICANT_COLUMN_NAME.Stage]: {
    index: 4,
    title: 'RentalPortal.ListingProfileApplicantsStageColumnKey',
    width: 160,
  },
  [APPLICANT_COLUMN_NAME.WaitingOn]: {
    index: 7,
    title: 'RentalPortal.ListingProfileApplicantsWaitingOnColumnKey',
    width: 200,
  },
}

export const APPLICANT_HIDDEN_COLUMNS = [APPLICANT_COLUMN_NAME.Chips]

export const APPLICANT_REQUIRED_COLUMNS = [
  APPLICANT_COLUMN_NAME.Reference,
  APPLICANT_COLUMN_NAME.Stage,
]

export const APPLICANT_SORTABLE_COLUMNS = [
  APPLICANT_COLUMN_NAME.Fit,
  APPLICANT_COLUMN_NAME.Listing,
  APPLICANT_COLUMN_NAME.Received,
  APPLICANT_COLUMN_NAME.Reference,
]

export const APPLICANT_VIEW_REGIME = {
  board: 'board',
  compare: 'compare',
  split: 'split',
  table: 'table',
}

export const APPLICANT_VIEW_REGIME_LABEL_KEY = {
  [APPLICANT_VIEW_REGIME.board]: 'RentalPortal.ApplicantViewBoardKey',
  [APPLICANT_VIEW_REGIME.compare]: 'RentalPortal.ApplicantViewCompareKey',
  [APPLICANT_VIEW_REGIME.split]: 'RentalPortal.ListingViewSplitKey',
  [APPLICANT_VIEW_REGIME.table]: 'RentalPortal.ApplicantViewTableKey',
}

export const APPLICANT_COMPARE_VIEW_TYPE = 'compare'

export const APPLICANT_PREVIEW_REGIME_AVAILABLE = true

export const APPLICANT_VIEW_TYPES = [
  ENTITY_LISTING_VIEW_TYPE.board,
  ENTITY_LISTING_VIEW_TYPE.boardWithPreview,
  ENTITY_LISTING_VIEW_TYPE.table,
  ENTITY_LISTING_VIEW_TYPE.tableWithPreview,
]

export const APPLICANT_ROW_ACTIONS = [
  {
    label: 'RentalPortal.ListingProfileApplicantsOpenActionOptionKey',
    permission: true,
    value: APPLICANT_ACTION_OPEN,
  },
]

export const APPLICANTS_FILTER_OPTION_LIST_ITEM = {
  [APPLICANTS_FILTER_PARAM.eligibility]:
    RentalPortalApplicantsEligibilityFilterListItem,
  [APPLICANTS_FILTER_PARAM.stage]: RentalPortalApplicantsStageFilterListItem,
}

export const APPLICANTS_PAYLOAD_FILTER_PARAM_GATE = {
  [APPLICANTS_FILTER_PARAM.eligibility]: 'hasMatch',
  [APPLICANTS_FILTER_PARAM.needsMyAction]: 'hasAttention',
}

export const APPLICANTS_LISTING_FIELD_NAME = 'listing'

export const APPLICANTS_LISTING_OPTIONS_SIZE = 200

export const APPLICANTS_AVAILABLE_FILTERS = [
  {
    name: APPLICANTS_FILTER_PARAM.needsMyAction,
    query_param: APPLICANTS_FILTER_PARAM.needsMyAction,
    title: 'RentalPortal.ListingNeedsMyActionFilterKey',
    type: TOGGLE_FILTER_TYPE,
  },
  {
    name: APPLICANTS_FILTER_PARAM.eligibility,
    options: Object.entries(MATCH_ELIGIBILITY_STATUSES).map(
      ([value, status]) => ({ label_key: status.text, value })
    ),
    placeholder: 'RentalPortal.MatchEligibilityFilterPlaceholderKey',
    query_param: APPLICANTS_FILTER_PARAM.eligibility,
    title: 'RentalPortal.MatchEligibilityFilterKey',
    type: SELECT_FILTER_TYPE,
  },
  {
    name: APPLICANTS_FILTER_PARAM.listing,
    options: EMPTY_LIST,
    placeholder: 'RentalPortal.ApplicantListingFilterPlaceholderKey',
    query_param: APPLICANTS_FILTER_PARAM.listing,
    title: 'RentalPortal.ApplicantListingColumnKey',
    type: SELECT_FILTER_TYPE,
  },
  {
    name: APPLICANTS_FILTER_PARAM.stage,
    options: APPLICANT_STAGE_LIST.map(stage => ({
      label_key: APPLICANT_STAGES[stage].text,
      value: stage,
    })),
    placeholder: 'RentalPortal.ApplicantStageFilterPlaceholderKey',
    query_param: APPLICANTS_FILTER_PARAM.stage,
    title: 'RentalPortal.ListingProfileApplicantsStageColumnKey',
    type: SELECT_FILTER_TYPE,
  },
  {
    name: 'received',
    placeholder: 'RentalPortal.ViewingDateRangeFilterPlaceholderKey',
    query_param: [
      APPLICANTS_FILTER_PARAM.receivedGte,
      APPLICANTS_FILTER_PARAM.receivedLte,
    ],
    title: 'RentalPortal.ApplicantReceivedColumnKey',
    type: DATE_FILTER_TYPE,
  },
  {
    name: APPLICANTS_FILTER_PARAM.source,
    options: Object.entries(RENTAL_PORTAL_APPLICANT_SOURCE_LABEL_KEY).map(
      ([value, labelKey]) => ({ label_key: labelKey, value })
    ),
    placeholder: 'RentalPortal.ApplicantPortalFilterPlaceholderKey',
    query_param: APPLICANTS_FILTER_PARAM.source,
    title: 'RentalPortal.ApplicantPortalColumnKey',
    type: SELECT_FILTER_TYPE,
  },
]
